import { render, staticRenderFns } from "./status-card.app.vue?vue&type=template&id=1545aa93&"
import script from "./status-card.app.vue?vue&type=script&lang=js&"
export * from "./status-card.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports